var map = {
	"./": 18305,
	"./App": 29241,
	"./App.css": 93508,
	"./App.js": 29241,
	"./App.test": 60754,
	"./App.test.js": 60754,
	"./PageRender": 77839,
	"./PageRender.jsx": 77839,
	"./Routes": 65227,
	"./Routes.jsx": 65227,
	"./assets/appstore.png": 74709,
	"./assets/background.png": 25665,
	"./assets/collection.png": 43393,
	"./assets/companies/comp-1.png": 81451,
	"./assets/companies/comp-2.png": 16805,
	"./assets/companies/comp-3.png": 35449,
	"./assets/companies/comp-4.png": 17443,
	"./assets/companies/comp-5.png": 1813,
	"./assets/companies/comp-6.png": 83523,
	"./assets/db.png": 93050,
	"./assets/delete-svg.gif": 61147,
	"./assets/docs.png": 7786,
	"./assets/forgot-hero.png": 78396,
	"./assets/forgot-password-bg.png": 14242,
	"./assets/grid-1.png": 13326,
	"./assets/grid-2.png": 94050,
	"./assets/hero.png": 70980,
	"./assets/login-bg.png": 19958,
	"./assets/login-hero.png": 92662,
	"./assets/login.png": 89520,
	"./assets/logos/logo-green.png": 50309,
	"./assets/logos/logo-white.png": 45745,
	"./assets/oshey.png": 85349,
	"./assets/playstore.png": 30740,
	"./assets/pp-2.png": 93412,
	"./assets/pp-3.png": 23811,
	"./assets/reset-img.png": 91425,
	"./assets/sign-up-bg.png": 77454,
	"./assets/success-icon.png": 31212,
	"./assets/svg/email_Icon.svg": 73514,
	"./assets/svg/home.svg": 98098,
	"./assets/svg/password_icon.svg": 35379,
	"./assets/users.png": 81961,
	"./components/brand/brand": 35716,
	"./components/brand/brand.jsx": 35716,
	"./components/button/button": 62294,
	"./components/button/button.jsx": 62294,
	"./components/dashboard-card/dashboard-card": 53677,
	"./components/dashboard-card/dashboard-card.jsx": 53677,
	"./components/database-card/database-card": 81938,
	"./components/database-card/database-card.jsx": 81938,
	"./components/default-header/default-header": 20965,
	"./components/default-header/default-header.jsx": 20965,
	"./components/foot-icon/foot-icon": 36891,
	"./components/foot-icon/foot-icon.jsx": 36891,
	"./components/footer/footer": 40621,
	"./components/footer/footer.jsx": 40621,
	"./components/input/input": 57157,
	"./components/input/input.jsx": 57157,
	"./components/loader/loader": 11959,
	"./components/loader/loader.jsx": 11959,
	"./components/modal-container/modal-container": 59546,
	"./components/modal-container/modal-container.jsx": 59546,
	"./components/nav/nav": 10827,
	"./components/nav/nav.jsx": 10827,
	"./components/profile-rounded/profile-rounded": 66431,
	"./components/profile-rounded/profile-rounded.jsx": 66431,
	"./components/profile/profile": 87838,
	"./components/profile/profile.jsx": 87838,
	"./components/sidebar/sidebar": 94760,
	"./components/sidebar/sidebar.jsx": 94760,
	"./components/testimonial-card/testimonial-card": 54915,
	"./components/testimonial-card/testimonial-card.jsx": 54915,
	"./data/Config": 42707,
	"./data/Config.js": 42707,
	"./data/Context": 75088,
	"./data/Context.jsx": 75088,
	"./data/Reducers": 57895,
	"./data/Reducers/": 57895,
	"./data/Reducers/ErrorReducer": 24832,
	"./data/Reducers/ErrorReducer.js": 24832,
	"./data/Reducers/UserReducer": 79573,
	"./data/Reducers/UserReducer.js": 79573,
	"./data/Reducers/adminSlice": 62111,
	"./data/Reducers/adminSlice.js": 62111,
	"./data/Reducers/collectionSlice": 69657,
	"./data/Reducers/collectionSlice.js": 69657,
	"./data/Reducers/databaseSlice": 66380,
	"./data/Reducers/databaseSlice.js": 66380,
	"./data/Reducers/documentsSlice": 53799,
	"./data/Reducers/documentsSlice.js": 53799,
	"./data/Reducers/index": 57895,
	"./data/Reducers/index.js": 57895,
	"./data/Store": 31974,
	"./data/Store.js": 31974,
	"./data/selectors/adminSelector": 55590,
	"./data/selectors/adminSelector.js": 55590,
	"./data/selectors/collectionSelector": 19886,
	"./data/selectors/collectionSelector.js": 19886,
	"./data/selectors/databaseSelector": 70768,
	"./data/selectors/databaseSelector.js": 70768,
	"./data/selectors/documentSelector": 24417,
	"./data/selectors/documentSelector.js": 24417,
	"./data/selectors/userSelector": 40130,
	"./data/selectors/userSelector.js": 40130,
	"./index": 18305,
	"./index.css": 51174,
	"./index.js": 18305,
	"./logo.svg": 31100,
	"./pages": 50322,
	"./pages/": 50322,
	"./pages/all-users": 25280,
	"./pages/all-users/": 25280,
	"./pages/all-users/index": 25280,
	"./pages/all-users/index.jsx": 25280,
	"./pages/dashboard": 74067,
	"./pages/dashboard/": 74067,
	"./pages/dashboard/index": 74067,
	"./pages/dashboard/index.jsx": 74067,
	"./pages/databases": 58485,
	"./pages/databases/": 58485,
	"./pages/databases/collections": 86166,
	"./pages/databases/collections/": 86166,
	"./pages/databases/collections/[id]": 89818,
	"./pages/databases/collections/[id]/": 89818,
	"./pages/databases/collections/[id]/index": 89818,
	"./pages/databases/collections/[id]/index.jsx": 89818,
	"./pages/databases/collections/index": 86166,
	"./pages/databases/collections/index.jsx": 86166,
	"./pages/databases/index": 58485,
	"./pages/databases/index.jsx": 58485,
	"./pages/index": 50322,
	"./pages/index.jsx": 50322,
	"./pages/profile": 56053,
	"./pages/profile/": 56053,
	"./pages/profile/index": 56053,
	"./pages/profile/index.jsx": 56053,
	"./reportWebVitals": 54013,
	"./reportWebVitals.js": 54013,
	"./screens/home": 17076,
	"./screens/home.jsx": 17076,
	"./screens/invite": 26541,
	"./screens/invite/": 26541,
	"./screens/invite/[id]": 95047,
	"./screens/invite/[id].jsx": 95047,
	"./screens/invite/index": 26541,
	"./screens/invite/index.jsx": 26541,
	"./screens/login": 65613,
	"./screens/login.jsx": 65613,
	"./screens/register": 41412,
	"./screens/register.jsx": 41412,
	"./screens/reset-password": 628,
	"./screens/reset-password.jsx": 628,
	"./setupTests": 79511,
	"./setupTests.js": 79511
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 18116;